//@flow
import { Cancel, Check } from "@mui/icons-material";
import { Button, Dialog, DialogActions, DialogContent, useMediaQuery } from '@mui/material';
import { useTheme } from "@mui/material/styles";
import * as React from 'react';
import { useTranslation } from "react-i18next";
import { EXHIBITION } from "../../../../locales/components/namespaces";
import DialogTransition from "../../../general/dialogTransition/dialogTransition";
import DialogHeader from "./dialogHeader";

type Props = {
	open: boolean,
	handleDialog: Function
}

const ConfirmDialog = (props: Props) => {
	const { t } = useTranslation(EXHIBITION)
	const {
		open,
		handleDialog,
		title,
		onYes = () => {
		},
		onNo = () => {
		},
		yesBtnText,
		noBtnText,
		hasBtnIcons = true,
		yesAction = true,
		noAction = true,
		children,
		maxWidth = 'xs',
		withLoadingButton = false,
		loading = false,
		yesBtnDisabled = false,
		yesBtnVariant = 'contained',
		sx = {},
		otherDialogProps = {}
	} = props;
	const theme = useTheme()
	const isDownSm = useMediaQuery(theme.breakpoints.down('sm'))
	const handleClose = (evt, details) => {
		if (details === 'backdropClick' || details === 'escapeKeyDown') return
		handleDialog(false)
	}
	return (
		<Dialog
			open={open}
			onClose={handleClose}
			maxWidth={maxWidth || 'xs'}
			sx={sx}
			slots={{
				transition: DialogTransition
			}}
			{...otherDialogProps}
		>
			<DialogHeader title={title} onClose={handleDialog} isDownSm={isDownSm}/>
			<DialogContent sx={{ p: isDownSm ? 2 : 4, pt: 3, pb: 1 }}>{children}</DialogContent>
			<DialogActions
				sx={{
					justifyContent: 'center',
					pb: noAction || yesAction ? 4 : 0
				}}
			>
				{yesAction && (
					<Button
						size={"small"}
						sx={{ width: isDownSm ? '100%' : 'auto' }}
						variant={yesBtnVariant}
						color={'highlight'}
						onClick={onYes}
						endIcon={hasBtnIcons ? <Check/> : null}
						{...withLoadingButton ? {
							loading: loading,
							loadingPosition: "end"
						} : {}}
						disabled={yesBtnDisabled}
					>
						{yesBtnText ? yesBtnText : t('OK')}
					</Button>
				)}
				{noAction && (
					<Button
						color="error"
						size={"small"}
						sx={{ width: isDownSm ? '100%' : 'auto' }}
						variant={"outlined"}
						onClick={onNo}
						startIcon={hasBtnIcons ? <Cancel/> : null}
					>
						{noBtnText ? noBtnText : t('Cancel')}
					</Button>
				)}
			</DialogActions>
		</Dialog>
	)
}

export default ConfirmDialog;